exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cp-layout-menu {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n}\n.cp-layout-menu > div {\n  padding: 25px 20px;\n  width: 100px;\n  height: 100px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  color: #999;\n  border-bottom: 1px solid #e5e5e5;\n  cursor: pointer;\n}\n.cp-layout-menu .active-menu {\n  position: relative;\n  color: #333;\n}\n.cp-layout-menu .active-menu:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 4px;\n  background-color: #3296FA;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/components/menu/index.less
// module id = 646
// module chunks = 0